ACC.registerpagebuttons = {
  errorInfo: function(resthis) {
    var errormsgValue = $(resthis).parents('.ph-signup__error').parent().attr('data-emptyContent');

    $(resthis).parents('.ph-signup__error').addClass('form_field_error ph-form_field_error');
    $(resthis).parents('.ph-signup__error').find('.ph-register__emptyvalue').text(errormsgValue);
  },

  removeInfo: function(resthis) {
    $(resthis).parents('.ph-signup__error').removeClass('form_field_error ph-form_field_error');
    $(resthis).parents('.ph-signup__error').find('.ph-register__emptyvalue').text('');
  },

  addRemove: function(perthis) {
    if ($(perthis).val() === '' || $(perthis).val() === null) {
      ACC.registerpagebuttons.errorInfo(perthis);
    } else {
      ACC.registerpagebuttons.removeInfo(perthis);
    }

    if ($(perthis).parents('.ph-postalcode__wrapper').length > 0 && $(perthis).val() !== '') {
      $(perthis).trigger('blur');
    }
  },

  selectFirst: function(selthis, getId) {
    var errorMessageSelectBox = $(selthis).parents('#' + getId).attr('data-emptyContent');

    $(selthis).parents('.ph-signup__error').addClass('form_field_error ph-form_field_error');
    $(selthis).parents('.ph-signup__error').find('.ph-register__emptyvalue').text(errorMessageSelectBox);
  },

  personalprof: function() {
    var getId = '',
        $fieldItem = $('#userTitle');

    if ($fieldItem.val() === '' || $fieldItem.val() === null) {
      getId = $fieldItem.parents('.ph-inputData').attr('id');
      ACC.registerpagebuttons.selectFirst($fieldItem, getId);

      return false;
    }

    return false;
  },
  organisationSelect: function() {
    if ($('#orgType').val() === '' || $('#orgType').val() === null) {
      ACC.registerpagebuttons.addRemove($('#orgType'));

      return false;
    }

    return false;
  },
  physicianorg: function() {
    if ($('#physicianState').val() === '' || $('#physicianState').val() === null) {
      ACC.registerpagebuttons.addRemove($('#physicianState'));

      return false;
    }

    return false;
  },

  forgotPasswordSuccess: function() {
    $.get($('.ph-registration__forgotpassword').data('url')).done(function(data) {
      $.colorbox({
        html: data,
        width: '100%',
        maxHeight: '400px',
        maxWidth: '522px',
        close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
        overlayClose: false,
        onOpen: function() {
          $('#validEmail').remove();
        },
        onComplete: function() {
          ACC.common.refreshScreenReaderBuffer();
          $('#diffUrl').attr('value', false);
        },
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    });
  },

  firstMethod: function() {
    var personalProfile = true,
        emailId = $('#emailAddressId').val();

    $('input[name="haveHealthCareAcct"]:checked').trigger('click');

    $('.ph-registration__personalinfo .ph-nonorgtype input[type="text"]').each(function() {
      if ($(this).val() === '') {
        personalProfile = false;
      }
    });

    if (personalProfile === false) {
      $('.ph-registration__personalinfo .ph-nonorgtype input[type="text"]').each(function() {
        ACC.registerpagebuttons.addRemove(this);
      });
      ACC.registerpagebuttons.personalprof();
    }

    ACC.registerpagebuttons.personalprof();

    if ($('.ph-registration__personalinfo .form_field_error').length > 0) {
      return false;
    }

    $.ajax({
      dataType: 'json',
      url: ACC.config.contextPath + '/register/validateUserId',
      type: 'GET',
      data: {
        emailId: emailId
      },
      success: function(result) {
        if (result === false) {
          location.hash = 'organisation';
        } else {
          $.colorbox({
            html: $('.ph-emailexists__parent').html(),
            width: '100%',
            maxHeight: '400px',
            maxWidth: '522px',
            close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
            overlayClose: false,
            onComplete: function() {
              ACC.common.refreshScreenReaderBuffer();
            },
            onClosed: function() {
              ACC.common.refreshScreenReaderBuffer();
            }
          });
        }
      }
    });

    return true;
  },

  nextbtnorgan: function() {
    $(document).on('click', '.ph-registration__nextbtnorgan', function() {
      ACC.registerpagebuttons.firstMethod();
    });
  },

  forgotpPasswordClick: function() {
    $(document).on('click', '.ph-registration__forgotpassword', function() {
      ACC.registerpagebuttons.forgotPasswordSuccess();
    });
  },

  emptyField: function(iterationInput) {
    if ($(iterationInput).val() === '' &&
    !$(iterationInput).hasClass('ph-identifierNumber') && !$(iterationInput).parents('.ph-inputData').hasClass('ph-physician_input')) {
      return true;
    }

    return false;
  },
  nextbtnaddress: function() {
    /* eslint-disable complexity */
    /* eslint-disable max-statements */
    $(document).on('click', '.ph-registration__nextbtnaddress', function() {
    /* eslint-enable max-statements */
    /* eslint-enable complexity */
      var organisationInfo = true,
          checkedVal = '',
          storeids = $('.localeids').text().split('-')[2].toUpperCase(),
          physicianOrg = true,
          $inputtext = $('.ph-registration__organisationinfo input[type="text"]:visible');

      ACC.registerpagebuttons.organisationSelect();


      function emptycheck(ethis) {
        var registrationParent = $(ethis).parents('.ph-inputData').hasClass('ph-registration__nlclasses'),
            registrationAccount = $(ethis).hasClass('ph-custaccountnumber');

        if (ACC.registerpagebuttons.emptyField(ethis) && checkedVal === 'Yes' && !registrationParent) {
          organisationInfo = false;
        }

        if (checkedVal === 'No' && $(ethis).val() === '' && !registrationAccount) {
          organisationInfo = false;
        }
      }

      if ($('.localeids').text().split('-')[0] === 'hhs') {
        checkedVal = 'Yes';
      } else {
        checkedVal = $('.haveHealthCareAcct-radio:checked').val();
      }


      if (storeids === 'NL' || storeids === 'AU' || storeids === 'IT') {
        if (checkedVal === 'Yes') {
          var expressionValue = '';

          if (storeids === 'NL' || storeids === 'AU') {
            expressionValue = '.ph-registration__organisationinfo input[type="text"]:not(#vatRegistrationNumber, #bigNumber, #commerceNumber)';
          } else if (storeids === 'IT') {
            expressionValue = '.ph-registration__organisationinfo input[type="text"]:not(#vatRegistrationNumber, #commerceNumber)';
          } else {
            expressionValue = '.ph-registration__organisationinfo input[type="text"]:not(#vatRegistrationNumber)';
          }

          $(expressionValue).each(function() {
            if (ACC.registerpagebuttons.emptyField(this)) {
              emptycheck(this);
              ACC.registerpagebuttons.errorInfo(this);
            }
          });
        }

        if (checkedVal === 'No') {
          $('.ph-registration__organisationinfo input[type="text"]:not(#custAccountNumber)').each(function() {
            if (ACC.registerpagebuttons.emptyField(this) && $(this).closest('.ph-inputData').attr('data-is-mandatory') === 'true') {
              emptycheck(this);
              ACC.registerpagebuttons.errorInfo($(this));
            }

            if ($(this).attr('id') === 'companyName' && ACC.registerpagebuttons.emptyField(this)) {
              organisationInfo = false;
              ACC.registerpagebuttons.errorInfo($('#' + $(this).attr('id')));
            }
          });
        }
      } else if (storeids === 'SG') {
        if (checkedVal === 'Yes') {
          $('.ph-registration__organisationinfo input[type="text"]:not(#vatRegistrationNumber)').each(function() {
            if ($(this).attr('id') !== 'commerceNumber' && ACC.registerpagebuttons.emptyField(this)) {
              organisationInfo = false;
              ACC.registerpagebuttons.errorInfo($(this));
            }
          });
        }

        if (checkedVal === 'No') {
          $inputtext.each(function() {
            var dataMandatoryVal = $(this).closest('.ph-inputData').attr('data-is-mandatory'),
                inputIdVal = $(this).attr('id');

            if ((inputIdVal === 'commerceNumber' || inputIdVal === 'vatRegistrationNumber') && ACC.registerpagebuttons.emptyField(this) && dataMandatoryVal === 'true') {
              organisationInfo = false;
              ACC.registerpagebuttons.errorInfo($(this));
            }

            if ($(this).attr('id') === 'companyName' && ACC.registerpagebuttons.emptyField(this)) {
              organisationInfo = false;
              ACC.registerpagebuttons.errorInfo($('#' + $(this).attr('id')));
            }
          });
        }
      } else {
        $inputtext.each(function() {
          if (ACC.registerpagebuttons.emptyField(this) && checkedVal === 'Yes') {
            organisationInfo = false;
          }

          if (checkedVal === 'No' && $('#companyName').val() === '') {
            organisationInfo = false;
          }
        });
      }


      if (storeids === 'NL' || storeids === 'SG') {
        if (organisationInfo === false) {
          return false;
        } else if (organisationInfo === true) {
          $('.ph-registration__organisationinfo .ph-inputData .ph-signup__error').removeClass('form_field_error ph-form_field_error');

          $('.ph-registration__organisationinfo .ph-inputData .ph-signup__error').find('.ph-register__emptyvalue').text('');
        } else if ($('.ph-registration__organisationinfo .form_field_error').length > 0) {
          return false;
        }
      } else if (organisationInfo === false) {
        $('.ph-registration__organisationinfo input[type="text"]').each(function() {
          if (ACC.registerpagebuttons.emptyField(this) && checkedVal === 'Yes') {
            ACC.registerpagebuttons.errorInfo(this);
          } else if (checkedVal === 'No') {
            var companyNameId = '#companyName';

            if (!$(companyNameId).val()) {
              ACC.registerpagebuttons.errorInfo($(companyNameId));
            }
          }
        });

        return false;
      } else if (organisationInfo === true) {
        ACC.registerpagebuttons.removeInfo($('#custAccountNumber'));
      } else if ($('.ph-registration__organisationinfo .form_field_error').length > 0) {
        return false;
      }


      if ($('.ph-physician').length > 0) {
        $('.ph-registration__organisationinfo .ph-physician input[type="text"]:not(#physicianAddress2, #physicianBusinessExtension, #physicianHouseNumber)').each(function() {
          if ($(this).val() === '') {
            physicianOrg = false;
          }

          if ($(this).attr('id') === 'physicianPostalCode' && $(this).val() !== '') {
            $(this).trigger('blur');
          }
        });

        if ($('select#physicianState').length > 0) {
          $('select#physicianState').trigger('blur');
        }
      }

      if (physicianOrg === false) {
        $('.ph-registration__organisationinfo .ph-physician input[type="text"]').each(function() {
          if (($(this).parents('.ph-registration__physicianaddress2').find('input').attr('name') !== 'physicianAddress2') && ($(this).attr('name') !== 'physicianHouseNumber')) {
            ACC.registerpagebuttons.addRemove(this);
          }
        });
        ACC.registerpagebuttons.physicianorg();


        if ($('.ph-physician').length === 0) {
          return false;
        }

        return false;
      }

      if ($('.ph-registration__organisationinfo .form_field_error').length > 0) {
        return false;
      }


      /*  If ($('.enableRegDocsToggle').html() === 'true') {
        if ($('.ph-fileSizeError').hasClass('hidden') === false || $('.ph-numfileserror').hasClass('hidden') === false || $('.ph-formateErrorMessage').hasClass('hidden') === false) {
          return false;
        }
      }
      */
      location.hash = 'addresses';

      return false;
    });
  },
  toggleDifferentAddress: function(eventType) {
    $('.ph-registration__organ').find('#billingOrganization').removeClass('ph-validatable');
    $('.ph-registration__organ').find('#shippingOrganization').removeClass('ph-validatable');

    if ($('.ph-add_different_billing').prop('checked') === true) {
      $('.newCustomer').show();
      $('.ph-registration__organ').find('#billingOrganization').show().addClass('ph-validatable');

      $('.newCustomer').find('input,select').attr('disabled', false);
    } else if (eventType === 'click') {
      $('.ph-registration__organ').find('#billingOrganization').hide();
    }

    if ($('.ph-add_different_shipping').prop('checked') === true) {
      $('.newCustomer').show();
      $('.ph-registration__organ').find('#shippingOrganization').show().addClass('ph-validatable');
      $('.newCustomer').find('input,select').attr('disabled', false);
    } else if (eventType === 'click') {
      $('.ph-registration__organ').find('#shippingOrganization').hide();
    }

    if ($('.localeids').text().split('-')[0] === 'hhs') {
      $('.newCustomer .ph-signup__error').removeClass('form_field_error ph-form_field_error');
      $('.ph-registration__organ').removeClass('ph-registration__second');
      $('.newCustomer .ph-signup__error .ph-register__emptyvalue').html('');
    }
  },
  regFirstPartList: function(storeId) {
    var phRegFirstpart = '.ph-registration__firstpart input[type="text"]:not(#vatRegistrationNumber)';

    if (storeId === 'FR' && $('#siret').is(':hidden')) {
      phRegFirstpart = '.ph-registration__firstpart input[type="text"]:not(#vatRegistrationNumber, #siret)';
    }

    return phRegFirstpart;
  },
  registrationClick: function() {
    $(document).on('click', '.ph-add_different_billing', function() {
      ACC.registerpagebuttons.toggleDifferentAddress('click');
    });
    $(document).on('click', '.ph-add_different_shipping', function() {
      ACC.registerpagebuttons.toggleDifferentAddress('click');
    });
    $(document).on('click', 'input[type="text"]', function() {
      $(this).parents('.ph-form_field_error').removeClass('ph-form_field_error form_field_error');
    });

    /* eslint-disable max-statements */
    /* eslint-disable complexity */
    $(document).on('click', '.ph-registration', function() {
    /* eslint-enable complexity */
      /* eslint-enable max-statements */

      var address = true,
          shippinBilling = true,
          storeids = $('.localeids').text().split('-')[2].toUpperCase(),
          $buyingPreferenceSelect = $('select#buyingPreference[multiple]');

      if ($buyingPreferenceSelect.length > 0) {
        var buyingPreferenceSelectVal = $buyingPreferenceSelect.val();

        $('#ph-buyingPreferenceOneStore').val(buyingPreferenceSelectVal);
      }

      function addressSelect(addthis) {
        if ($(addthis).val() === '' || $(addthis).val() === null) {
          address = false;
        }
      }

      if (storeids === 'FR') {
        $('.ph-registration__firstpart input[type="text"]:not(#vatRegistrationNumber)').each(function() {
          addressSelect(this);
        });
      } else {
        $('.ph-registration__firstpart input[type="text"]').each(function() {
          addressSelect(this);
        });
      }

      $('.ph-registration__firstpart select').each(function() {
        addressSelect(this);
      });

      if (address === false) {
        $(ACC.registerpagebuttons.regFirstPartList(storeids)).each(function() {
          if (($(this).attr('name') !== 'companyAddressSecondary') && ($(this).attr('name') !== 'companyHouseNumber')) {
            ACC.registerpagebuttons.addRemove(this);
          }
        });

        $('.ph-registration__firstpart select').each(function() {
          ACC.registerpagebuttons.addRemove(this);
        });
      }

      $('.newCustomer').find('.ph-validatable input[type="text"]:not(.ph-optionalfield)').each(function() {
        ACC.registerpagebuttons.addRemove(this);
      });
      $('.newCustomer').find('.ph-validatable select').each(function() {
        ACC.registerpagebuttons.addRemove(this);
      });

      if ($('.ph-registration__second').length > 0) {
        $('.ph-registration__second input[type="text"]:not(.ph-optionalfield),.ph-registration__second select').each(function() {
          if (!$(this).hasClass('disable')) {
            if ($(this).val() === '' || $(this).val() === null) {
              shippinBilling = false;
            }
          }
        });

        if (shippinBilling === false) {
          $('.ph-registration__second input[type="text"]:not(.ph-optionalfield),.ph-registration__second select').each(function() {
            if (!$(this).hasClass('disable')) {
              ACC.registerpagebuttons.addRemove(this);
            }
          });

          return false;
        } else if ($('.ph-registration__second').length > 0) {
          if ($('.form_field_error').length > 0) {
            return false;
          }
        }
      } else if ($('.ph-registration__firstpart .form_field_error').length > 0) {
        return false;
      }

      if ($('.newCustomer').find('.ph-validatable .form_field_error').length > 0) {
        return false;
      }

      if ($('.ph-add_different_billing').prop('checked') === false && $('.haveHealthCareAcct-radio:checked').val() === 'No') {
        if ($('#companyName').val() !== '') {
          $('#billOrgName').val($('#companyName').val());
        }

        if ($('#companyHouseNumber').val() !== '') {
          $('#billOrgHouseNumber').val($('#billOrgHouseNumber').val());
        }

        if ($('#companyAddressPrimary').val() !== '') {
          $('#billOrgAddress').val($('#companyAddressPrimary').val());
        }

        if ($('#companyAddressSecondary').val() !== '') {
          $('#billOrgAddress2').val($('#companyAddressSecondary').val());
        }

        if ($('#city').val() !== '') {
          $('#billOrgCity').val($('#city').val());
        }

        if ($('#organisationCountry').val() !== '') {
          $('#billOrgCountry').val($('#organisationCountry').val());
        }

        if ($('#state').val() !== '') {
          $('#billOrgState').val($('#state').val());
        }

        if ($('#postalCode').val() !== '') {
          $('#billOrgPostCode').val($('#postalCode').val());
        }
      }

      if ($('.ph-add_different_shipping').prop('checked') === false && $('.haveHealthCareAcct-radio:checked').val() === 'No') {
        if ($('#companyName').val() !== '') {
          $('#shipOrgName').val($('#companyName').val());
        }

        if ($('#companyHouseNumber').val() !== '') {
          $('#shippOrgHouseNumber').val($('#billOrgHouseNumber').val());
        }

        if ($('#companyAddressPrimary').val() !== '') {
          $('#shipOrgAddress').val($('#companyAddressPrimary').val());
        }

        if ($('#companyAddressSecondary').val() !== '') {
          $('#shippOrgAddress2').val($('#companyAddressSecondary').val());
        }

        if ($('#city').val() !== '') {
          $('#shipOrgCity').val($('#city').val());
        }

        if ($('#organisationCountry').val() !== '') {
          $('#shipOrgCountry').val($('#organisationCountry').val());
        }

        if ($('#state').val() !== '') {
          $('#shipOrgState').val($('#state').val());
        }

        if ($('#postalCode').val() !== '') {
          $('#shipOrgPostCode').val($('#postalCode').val());
        }
      }

      if ($('.enableRegDocsToggle').html() === 'true') {
        if ($('.ph-status-message').attr('data-sizeError') === true || $('.ph-status-message').attr('data-wrongFile') === true || $('.ph-status-message').attr('data-numFilesError') === true) {
          return false;
        }
      }

      if ($('.ph-sitekey').length === 0) {
        $('.ph-loader__default').show();
        $('#registerForm').submit();
      }

      return false;
    });
  }
};

$(document).ready(function() {
  ACC.registerpagebuttons.forgotpPasswordClick();
  ACC.registerpagebuttons.nextbtnorgan();
  ACC.registerpagebuttons.nextbtnaddress();
  ACC.registerpagebuttons.registrationClick();
});
